// extracted by mini-css-extract-plugin
module.exports = {"button":"native-button_button__Iabj1","no-border":"native-button_no-border__LHOho","button-padding":"native-button_button-padding__xncbB"};